import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { PropsWithChildren, useEffect, useState } from 'react';

import { useAuthHeaders, useGetAccessToken } from 'components/Auth/hooks';

export const MsalAuth = ({ children }: PropsWithChildren) => {
  const [authorized, setAuthorized] = useState(false);
  const getAccessToken = useGetAccessToken();
  const {
    instance,
    inProgress,
    accounts: [activeAccount],
  } = useMsal();

  useAuthHeaders();

  useEffect(() => {
    instance.setActiveAccount(activeAccount);
  }, [instance, activeAccount]);

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      getAccessToken().then(() => {
        setAuthorized(true);
      });
    }
  }, [inProgress, getAccessToken]);

  return authorized && children;
};
